'use strict';

const libPictView = require('pict-view');
const libProjectEditWorkspace = require('./ProjectEditWorkspace.js');

// One small addition on top of the reused .pew-* form styles: the required-field mark.
const CCW_CSS = /*css*/`
	.ccw-req { color: var(--theme-color-status-error, #cf5b5b); font-weight: 700; }
`;

/**
 * ContractCreateWorkspace — the bespoke Contract CREATE screen (reached by the app-router Create bridge on
 * #/PSRS/Contract/Create, which shadows the generic recordset create form so "+ New" opens the curated
 * experience). A thin shell: all data, behavior, and hand-built form HTML live in the ContractCreateWorkspace
 * provider, which assigns into the #CCW-Body mount. Reuses the Edit workspace's .pew-* CSS.
 */
class ContractCreateWorkspace extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get provider() { return this.pict.providers.ContractCreateWorkspace; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider) { tmpProvider.render(); }
		return super.onAfterRender(pRenderable);
	}
}

module.exports = ContractCreateWorkspace;

module.exports.default_configuration =
{
	ViewIdentifier: 'ContractCreateWorkspace',
	DefaultRenderable: 'ContractCreateWorkspaceWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: libProjectEditWorkspace.default_configuration.CSS + CCW_CSS,
	Templates:
	[
		{
			Hash: 'ContractCreateWorkspace-Wrap',
			Template: /*html*/`<div class="pew-wrap"><div id="CCW-Body"></div></div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'ContractCreateWorkspaceWrap',
			TemplateHash: 'ContractCreateWorkspace-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};
